import { t } from "@lingui/macro";
import { MoonIcon, SunIcon } from "@phosphor-icons/react";
import { useTheme } from "@reactive-resume/hooks";
import { Button } from "@reactive-resume/ui";
import type { Variants } from "framer-motion";
import { motion } from "framer-motion";
import { useMemo } from "react";

type Props = {
  size?: number;
  className?: string;
};

export const ThemeSwitch = ({ size = 20, className }: Props) => {
  const { theme, setTheme } = useTheme();

  const isDark = theme === "dark";

  const handleToggle = () => {
    setTheme(isDark ? "light" : "dark");
  };

  const variants: Variants = useMemo(() => {
    return {
      light: { x: 0, rotate: 0 },
      dark: { x: 0, rotate: 180 },
    };
  }, []);

  return (
    <Button size="icon" variant="ghost" className={className} onClick={handleToggle}>
      <div className="cursor-pointer overflow-hidden" style={{ width: size, height: size }}>
        <motion.div 
          animate={isDark ? "dark" : "light"} 
          variants={variants} 
          transition={{ duration: 0.3 }}
          className="flex items-center justify-center"
        >
          {isDark ? (
            <MoonIcon size={size} aria-label={t`Switch to Light Mode`} />
          ) : (
            <SunIcon size={size} aria-label={t`Switch to Dark Mode`} />
          )}
        </motion.div>
      </div>
    </Button>
  );
};
